<template>
  <div class="indexDetail">
    <topNav :title="$t('indexDetail_title')"></topNav>

    <div class="search-bar" v-if="isMultileHotel">
      <div class="search">
        <i class="iconfont icon-sousuo"></i>
        <input type="text"
               id='searchInput'
               x-webkit-speech
               v-model='searchText'
               name=""
               :placeholder="$t('licManage_hotelCode')">
        <div class="cleartext"
             @click="searchText='';searchTextTrue=''"
             v-if="searchText != ''">
          <i class="iconfont icon-cuowu"></i>
        </div>
      </div>
      <div class="searct_btn"
           @click='searchTextTrue=searchText'>{{ $t('search') }}
      </div>
    </div>

    <div class="topNav clearfix topDis">
      <template v-if="isMultileHotel">
        <datepik @change='dateChange'
                 limit="none"
                 step="1"></datepik>
        <ul class="nav reveune"
            :class='{show:showRevenueState}'>
          <li class="selected"
              @click="selectList('showRevenueState')"><i class="iconfont icon-paixu"></i>{{ items[selected].dis }}
            {{ $t('indexDetail_sort') }}
          </li>
          <template v-for="(item,key) in items">
            <li class="list"
                @click="selectState($event,key)"
                :class='{active:selected==key}'
                :key="key">{{ item.dis }} {{ $t('indexDetail_sort') }}
            </li>
          </template>
          <i class="iconfont icon-xia"></i>
        </ul>
      </template>
      <template v-else>
        <datepik @change='dateChange'
                 style="margin:0 auto;float:none;"
                 limit="none"
                 step="1"></datepik>
      </template>
    </div>

    <div style="padding: 15px;padding-top:10px;" v-show='isSimpleMode'>
      <ul class="hotel"
          v-for="(item,index) in report"
          v-show="(searchTextTrue && (item.hotelName.indexOf(searchTextTrue) > -1)) || !searchTextTrue"
          :key="item.code">
        <li class="title"
            @click="goRevenueReport(item)"
            v-if='!item.isTotalItem'>
          <div class="left-name">
            <svg class="icon"
                 aria-hidden="true"
                 v-if="index<=2">
              <use :xlink:href="'#icon-pm'+index"></use>
            </svg>
            <span v-else>{{ index + 1 }}</span>
            {{ item.hotelName }}
          </div>
          <span v-show="item.hotelCode" class="iconfont icon-you1"></span>
        </li>
        <li v-for="i2 in items"
            :key="i2.key">
          <p class="Con_tt">{{ i2.dis }}</p>
          <p class="Con_ff"
             v-if="i2.m == '%'">{{ item[i2.key] }}%</p>
          <p class="Con_ff"
             v-else-if="i2.m == 'm'"
             v-html="$formatMoney(item[i2.key],dis,true,'￥', false, i2.noDisplayW, i2.noCount)"></p>
          <p class="Con_ff"
             v-else>{{ item[i2.key] }}</p>
        </li>
      </ul>
    </div>

    <div class='table-container'
         :class='{"heightAuto": !isSimpleMode}'>
      <vxe-table
        border
        resizable
        :height="tableHeight"
        highlight-hover-row
        ref="xTable"
        :show-footer="showFooter"
        :footer-method="footerMethod"
        footer-cell-class-name="table-footer"
        :data="filterReport">
        <vxe-table-column field='hotelName'
                          title="酒店名称"
                          width="100"
                          fixed="left"></vxe-table-column>
        <vxe-table-column v-for='(item,index) in items'
                          :title='item.dis'
                          :key="'vxe-table-column' + index"
                          width="100">
          <template v-slot="{ row }">
            <span>{{ countAmount(row, item) }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="toggleBtn"
         @click='toggleShowMode'>
      <span v-if='isSimpleMode'>表格</span>
      <span v-else>排行榜</span>
    </div>
  </div>
</template>

<script>
import {
  Toast
} from 'mint-ui';
import _ from 'lodash';
import '../../../static/fonts/iconfont.js';

export default {
  data() {
    var dataDisplayW = localStorage.getItem('dataDisplayW') == 'yes'

    return {
      searchText: '',
      searchTextTrue: '',

      homeInfo: [],
      showFooter: true,
      isSimpleMode: true,
      searchOption: {
        date: null, //日期（空时当前营业日）
        pageIndex: 1,
        pageSize: 20,
        sort: 'rentRate'
      },
      tableHeight: window.innerHeight - 170,
      isMultileHotel: false,
      items: [],
      report: [],
      dItems: [{
        key: 'rentRate',
        dis: this.$t('indexDetail_rentRate'),
        m: '%'
      },
        {
          key: 'revPar',
          dis: 'revPar',
          m: 'm',
          noDisplayW: dataDisplayW ? 'yes' : '',
          noCount: dataDisplayW ? 'yes' : ''
        },
        {
          key: 'revenue',
          dis: this.$t('indexDetail_revenue'),
          m: 'm'
        },
        {
          key: 'roomrevenue',
          dis: this.$t('indexDetail_roomrevenue'),
          m: 'm'
        },
        {
          key: 'foodrevenue',
          dis: this.$t('indexDetail_foodrevenue'),
          m: 'm'
        },
        {
          key: 'avgPrice',
          dis: this.$t('indexDetail_avgPrice'),
          m: 'm',
          noDisplayW: dataDisplayW ? 'yes' : '',
          noCount: dataDisplayW ? 'yes' : '',
        },
        {
          key: 'revMem',
          dis: this.$t('indexDetail_revMem'),
          m: 'm'
        },
        {
          key: 'revEnt',
          dis: this.$t('indexDetail_revEnt'),
          m: 'm'
        },
        {
          key: 'revHrs',
          dis: this.$t('indexDetail_revHrs'),
          m: 'm'
        },
        {
          key: 'otherrevenue',
          dis: this.$t('indexDetail_otherrevenue'),
          m: 'm'
        },
        {
          key: 'ttl',
          dis: this.$t('index_homeData_angle_allNum'), // 总房数
          // m: 'm'
        }
      ],
      showRevenueState: false,
      selected: 0,
      loading: false,
      dis: 'k',
      canGoDetail: false,
    };
  },
  mounted() {
    this.getData();
    this.getFunctions();
  },
  methods: {
    getFunctions(){
      this.$http.get('/mobilepmsapi/sys/myFunciton').then(res => {
        if (res.data.result == 0) {
          var arr = res.data.retVal || []
          var canGoDetail = false
          arr.map((item) => {
            item.funtions.map((item2) => {
              if(item2.url == '/revenueReport'){
                canGoDetail = true
              }
            })
          })
          this.canGoDetail = canGoDetail
        }
      });
    },
    goRevenueReport(item) {
      if(this.canGoDetail){
        if (item.hotelCode) {
          this.$router.push('/revenueReport?redirect=/indexDetail&name=' + item.hotelName + '&code=' + item.hotelCode) // TODO
        }
      } else {
        Toast({
          message: '没有查看营收情况的权限',
          position: 'bottom',
          duration: 3000
        });
      }
    },
    footerMethod({columns, data}) {
      if (this.searchTextTrue) {
        return []
      } else {
        return [this.homeInfo]
      }
    },
    toggleShowMode() {
      this.isSimpleMode = !this.isSimpleMode
    },
    countAmount(row, showType) {
      if (showType.m == '%') {
        return row[showType.key] + '%'
      } else if (showType.m == 'm') {
        return this.formatTableMoney(row[showType.key], this.dis, true, '￥', showType.noDisplayW)
      } else {
        return row[showType.key]
      }
    },
    formatTableMoney(money, dis, bs, bstart, noDisplayW ) {
      if (!money) {
        money = 0;
      }
      let language = this.$getLanguage();
      let ret = 0;
      let d = '';
      if (localStorage.getItem('dataDisplayW') == 'yes') {
        ret = (money / 10000).toFixed(2);
        if(noDisplayW == 'yes'){
          d = ''
        } else {
          d = this.$t('tenThousand');
        }
      } else {
        if (dis == 'k' || language == 'en_US') {
          if (money >= 1000000) {
            ret = (money / 1000000).toFixed(2);
            d = 'M';
          } else if (money >= 1000) {
            ret = (money / 1000).toFixed(2);
            d = 'K';
          } else {
            ret = money;
          }
        } else {
          if (money >= 100000000) {
            ret = (money / 100000000).toFixed(2);
            d = this.$t('hundredmillion');
          } else if (money >= 10000) {
            ret = (money / 10000).toFixed(2);
            d = this.$t('tenThousand');
          } else {
            ret = money;
          }
        }
      }
      return ((bstart && bs) ? bstart : '') + ret + ((bs && d) ? d : (d || ''));
    },

    getData() {
      this.$http
        .post('/mobilepmsapi/report/getHomeInfoDetail', this.searchOption)
        .then(res => {
          if (res.data.result == 0) {
            this.report = res.data.retVal.list;
            this.loading = false;
            if (res.data.retVal.dis) {
              this.dis = res.data.retVal.dis;
            }
            if (this.items.length == 0) {
              if (res.data.retVal.setting.length == 0) {
                res.data.retVal.setting = 'rentRate,revPar,revenue,roomrevenue,foodrevenue,otherrevenue'.split(
                  ','
                );
              }
              res.data.retVal.setting.forEach((val, key, arr) => {
                for (let i = 0; i < this.dItems.length; i++) {
                  if (val == this.dItems[i].key) {
                    this.items.push(this.dItems[i]);
                    break;
                  }
                }
              });
            }
            if (this.report.length > 1) {
              this.isMultileHotel = true
              this.getHomeInfo(res.data.retVal.setting)
            }
          } else {
            Toast({
              message: res.data.msg,
              position: 'bottom',
              duration: 3000
            });
          }
        });
    },
    getHomeInfo(setting) {
      this.$http.get('/mobilepmsapi/sys/homeInfo?date=' + this.searchOption.date).then(res => {
        if (res.data.result == 0) {
          let retVal = res.data.retVal;
          let homeInfo = []
          homeInfo[0] = '合计'
          console.log('c', this.items)
          this.items.map((item, index) => {
            let temp = this.countAmount(retVal, item)
            // homeInfo.push(retVal[item.key])
            homeInfo.push(temp)
          })
          this.homeInfo = homeInfo
          this.$refs.xTable.updateFooter()
        }
      });
    },
    selectList(item) {
      this[item] = ~this[item];
    },
    selectState(event, key) {
      event.cancelBubble = true;
      this.showRevenueState = false;
      this.selected = key;
      this.searchOption.sort = this.items[this.selected].key;
      this.getData();
    },
    getNextPage() {
      if (this.nextBtn) {
        this.searchOption.pageIndex += 1;
        this.loading = true;
        this.getData();
      }
    },
    dateChange(time) {
      this.searchOption.date = time;
      this.getData();
    }
  },
  computed: {
    filterReport() {
      if (this.searchTextTrue) {
        return this.report.filter((item) => {
          return item.hotelName.indexOf(this.searchTextTrue) > -1
        })
      } else {
        return this.report || []
      }
    }
  },
  components: {}
};
</script>

<style lang="less">
.indexDetail {
  height: auto !important;
  box-sizing: border-box;

  .search-bar {
    width: 100%;
    padding: 0.18666667rem 15px;
    box-sizing: border-box;
    background: #efefef;
    display: flex;
    align-items: center;

    .search {
      margin-left: 0.14rem;
      border-radius: 0.44rem;
      height: 40px;
      background-color: #f7f8fa;
      padding: 0 0.26666667rem;
      overflow: hidden;
      box-sizing: border-box;
      flex: 1;

      i.icon-sousuo {
        vertical-align: bottom;
        font-size: 0.42666667rem;
        color: #ccc;
        line-height: 40px;
      }

      input {
        padding-left: 0.2rem;
        vertical-align: middle;
        background-color: #f7f8fa;
        outline: 0;
        border: 0;
        height: 100%;
        width: 70%;
      }

      .cleartext {
        float: right;

        i.icon-cuowu {
          line-height: 0.32rem;
          background-color: #c3c3c3;
          border-radius: 50%;
          font-size: 0.32rem;
          text-align: center;
          color: #fff;
          padding: 0.13333333rem;
          margin-top: 8px;
          -webkit-transform-origin-x: 0;
          transform: scale(0.6);
          -webkit-transform: scale(0.6);
          width: 0.32rem;
          display: inline-block;
        }
      }
    }

    .searct_btn {
      box-sizing: border-box;
      font-size: 0.32rem;
      color: #5b5b5b;
      width: 80px;
      height: 40px;
      line-height: 40px;
      border-radius: 5px;
      text-align: center;

      &:active {
        background: #ccc;
      }
    }
  }

  .table-footer {
    background: #deeef9;
    font-weight: bold;
  }

  .table-container {
    overflow: hidden;
    height: 0;
    position: absolute;
    width: 100%;

    .vxe-table {
      font-size: 13px;
    }

    &.heightAuto {
      padding: 10px;
      box-sizing: border-box;
      height: auto;
    }
  }

  .toggleBtn {
    position: fixed;
    bottom: 80px;
    right: 0px;
    width: 30px;
    height: 80px;
    background: #ffa756;
    color: #fff;
    text-align: center;
    z-index: 10;
    border-radius: 8px 0 0 8px;
    align-items: center;
    display: flex;
    justify-content: space-around;

    > span {
      display: inline-block;
      line-height: 16px;
      width: 20px;
    }

    &:active {
      background: darken(#ff8000, 5%)
    }

    .iconfont {
      line-height: 45px;
      font-size: 20px;
    }
  }

  .topNav {
    height: 40px;
    background-color: #fff;
    width: 100%;
    box-sizing: border-box;
    padding: 0;

    .pik_calendar {
      float: left;
      margin-left: 0.5rem;
    }

    .zb {
      float: rightleft;
      height: 40px;
      line-height: 40px;
    }

    .nav {
      position: relative;
      height: 100%;
      float: left;
      z-index: 22;
      overflow: hidden;
      line-height: 40px;

      .icon-xia {
        position: absolute;
        top: 0;
        right: 0;
        line-height: 40px;
        color: #000;
        z-index: 1;
      }
    }

    .reveune {
      width: 4.4rem;
      position: absolute;
      right: 0;
      height: 1rem;
      overflow: hidden;

      i {
        font-size: 0.5rem;
        color: #999;
      }

      .selected {
        overflow: hidden;
        height: 100%;
        line-height: 40px;
        box-sizing: border-box;
        padding-right: 16px;
        text-align: center;
        padding-left: 10px;
        background-color: #fff;
      }

      .list {
        overflow: hidden;
        height: 100%;
        line-height: 40px;
        box-sizing: border-box;
        padding-right: 16px;
        text-align: center;
        padding-left: 10px;
        background-color: #fff;

        &.active {
          font-size: 0.37rem;
          color: #f69c2d;
        }
      }

      .icon-xia {
        right: 10px;
        top: 3px;
      }

      &.show {
        height: auto;
        box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.15);

        .icon-xia {
          transform: rotate(180deg);
        }
      }
    }
  }

  .hotel {
    box-shadow: 5px 0px 20px #ddd;
    border-radius: 3px;
    background: #fff;
    padding-bottom: 15px;
    margin-bottom: 15px;

    li {
      padding: 16px auto;
      width: 33%;
      display: inline-block;
      height: 72px;
      text-align: center;

      .Con_tt {
        color: #aaa;
        font-size: 12px;
        margin-top: 16px;
        line-height: 20px;
      }

      .Con_ff {
        font-size: 20px;
        line-height: 30px;
      }

      .Con_ff small {
        vertical-align: baseline;
        font-size: 0.32rem;
      }
    }

    .title {
      width: 100%;
      padding: 10px 15px;
      padding-right: 0;
      font-size: 16px;
      height: 50px;
      text-align: left;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eaeaea;

      &:active {
        background: #eaeaea;
      }

      .left-name {
        display: flex;
        align-items: center;
      }

      svg {
        width: 24px;
        height: 24px;
        padding-right: 5px;
      }

      span {
        font-size: 24px;
        font-weight: bold;
        color: #999;
        padding-right: 5px;
      }

      .iconfont {
        font-size: 40px !important;
        position: relative;
        top: 2px;
        color: #ccc;
        font-weight: 100;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// indexDetail.vue?4dc02d49